import ArgonBox from 'component/Argon/ArgonBox';

const routes = [
  {
    type: 'collapse',
    name: 'หน้าหลัก',
    key: 'dashboards',
    route: '/dashboards',
    icon: <ArgonBox component="i" color="primary" fontSize="14px" className="ni ni-app" />,
    noCollapse: true,
  },
  {
    type: 'collapse',
    name: 'รายการสั่งซื้อ',
    key: 'order',
    route: '/order',
    icon: <ArgonBox component="i" color="primary" fontSize="14px" className="ni ni-single-copy-04" />,
    noCollapse: true,
  },
  {
    type: 'collapse',
    name: 'ค้นหากรมธรรม์',
    key: 'search',
    route: '/search',
    icon: <ArgonBox component="i" color="primary" fontSize="14px" className="ni ni-zoom-split-in" />,
    noCollapse: true,
  },
  {
    type: 'collapse',
    name: 'รถเข็น',
    key: 'cart',
    route: '/cart',
    icon: <ArgonBox component="i" color="primary" fontSize="14px" className="ni ni-cart" />,
    noCollapse: true,
  },
  {
    type: 'collapse',
    name: 'ซื้อกรมธรรม์ (MOU)',
    key: 'policy-mou',
    route: '/policy-mou',
    icon: <ArgonBox component="i" color="primary" fontSize="14px" className="ni ni-single-copy-04" />,
    noCollapse: true,
  },
  // {
  //   type: 'collapse',
  //   name: 'มติ 5 ก.ค',
  //   key: 'policy-ewp',
  //   route: '/policy-ewp',
  //   icon: <ArgonBox component="i" color="primary" fontSize="14px" className="ni ni-single-copy-04" />,
  //   noCollapse: true,
  // },
  // {
  //   type: 'collapse',
  //   name: 'ซื้อเพื่อต่ออายุใบอนุญาตทำงาน',
  //   key: 'policy-ewp-ext',
  //   route: '/policy-ewp-ext',
  //   icon: <ArgonBox component="i" color="primary" fontSize="14px" className="ni ni-single-copy-04" />,
  //   noCollapse: true,
  // },
];

export default routes;
